<template>
    <div>
        <h4>About</h4>
        <span style="white-space: pre-wrap;">{{msg}}</span>
        <!-- <p>{{msg}}</p> -->
    </div>
</template>
<script>
    export default {
        data () {
            return {
                msg: "本程序仅用于产品评估交流使用。程序与文档的版权归北京蓝云天信息技术有限公司所有，未经许可，不得用于商业用途。\n “蓝云天” 是北京蓝云天信息技术有限公司的注册商标。"
            }
        }
    }
</script>